import axios from "axios";

import appSettings from "../../../config/config";

const getBusinesses = async (wlAccountId) => {
  const response = await axios.get(
    appSettings.serverlessUrl + `/wl/api/account/${wlAccountId}/business/list`
  );
  return response.data.businesses || [];
};

const updateBusinessToPremium = async (
  wlAccountId,
  businessDetails,
  discountCode
) => {
  await axios.post(
    appSettings.serverlessUrl +
      `/wl/api/account/${wlAccountId}/business/${businessDetails.id}/update-to-premium`,
    {
      discountCode,
    }
  );
};

export default {
  getBusinesses,
  updateBusinessToPremium,
};
